import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const WILL_APPEAL = {
  YES: 'yes',
  NO: 'no',
} as const;

export const WILL_APPEAL_NAME = 'will_appeal';

interface Props {
  name?: string;
}

export const RadioGroupWillAppeal: FC<Props> = ({
  name = WILL_APPEAL_NAME,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{i18n.t('Czy zamierzasz się odwoływać?')}</FormLabel>
          <FormControl>
            <RadioGroup {...field} layout={'vertical'}>
              <RadioItem
                data-testid={`${name}-radio-group-${WILL_APPEAL.YES}`}
                value={WILL_APPEAL.YES}
                label={i18n.t('Tak / jestem w trakcie')}
              />
              <RadioItem
                data-testid={`${name}-radio-group-${WILL_APPEAL.NO}`}
                value={WILL_APPEAL.NO}
                label={i18n.t('Nie')}
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
